import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";
import { FeaturedProject, ProjectCard } from "../components";

const Projects = ({ projects }) => {
  // Update to check for the featured property instead of a tag
  const featuredIndex = projects?.findIndex(project => project.featured === true);

  return (
    <>
      <StyledProjects>
        <motion.div 
          className="page-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1>PROJECTS</h1>
          <motion.div 
            className="title-bar"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          />
        </motion.div>
        
        {featuredIndex > -1 && (
          <div className="featured-projects">
            <FeaturedProject {...projects[featuredIndex]} />
          </div>
        )}
          <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >          <h2>OTHER PROJECTS</h2>
          <motion.div 
            className="section-gradient-bar" 
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          />
        </motion.div>
        
        <div className="project-grid">
          {/* Update the filter to use featured property instead of tags */}
          {projects?.filter(project => project.featured !== true).map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </StyledProjects>
    </>
  );
};

const StyledProjects = styled(motion.div)`
  position: relative;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 0;
  
  .page-title {
    text-align: center;
    margin-bottom: 3rem;
    
    h1 {
      font-size: 2.5rem;
      font-weight: 800;
      letter-spacing: 0.15em;
      color: var(--heading-text);
      margin-bottom: 0.75rem;
    }
    
    .title-bar {
      height: 3px;
      width: 80px;
      margin: 0 auto;
      background: linear-gradient(
        90deg,
        var(--vibrant, #4a5bef) 0%,
        var(--accent-color, #61DAFB) 100%
      );
      border-radius: 2px;
      transform-origin: center;
    }
  }
  .section-title {
    text-align: center;
    margin: 5rem 0 3rem;
    
    h2 {
      font-size: 1.5rem;
      color: var(--primary-text);
      letter-spacing: 0.15em;
      font-weight: 700;
      margin-bottom: 0.75rem;
    }
    
    .section-gradient-bar {
      height: 3px;
      width: 80px;
      margin: 0 auto;
      background: linear-gradient(
        90deg,
        var(--vibrant, #4a5bef) 0%,
        var(--accent-color, #61DAFB) 100%
      );
      border-radius: 2px;
      transform-origin: center;
    }
  }
  
  .featured-projects {
    margin-bottom: 2rem;
  }
  
  .project-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2.5rem;
  }
  
  @media (max-width: 768px) {
    padding: 3rem 1rem;
    
    .page-title h1 {
      font-size: 2rem;
    }
    
    .section-title {
      margin: 3rem 0 2rem;
      
      h2 {
        font-size: 1.3rem;
      }
    }
    
    .project-grid {
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
      gap: 1.8rem;
    }
  }
`;

export default Projects;
